import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ExpenseLiability} from '../../../../shared/models/socialSupport/expenseLiability';
import {AppActions} from '../../../actions';

export interface ExpenseLiabilityState {
  liabilities: ExpenseLiability[] | null;
}

const initialState: ExpenseLiabilityState = {
  liabilities: null,
};

export const expenseLiabilitiesSlice = createSlice({
  name: '@@eskso/socialSupport/expenseLiability',
  initialState,
  reducers: {
    setExpenseLiabilities: (state, action: PayloadAction<ExpenseLiability[]>) => {
      return {
        ...state,
        liabilities: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const expenseLiabilities = expenseLiabilitiesSlice.reducer;
